import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { TimelineService } from '../../shared/services/timeline.service';
import { Subject } from 'rxjs';
import { PermissionService } from '../../shared/services/permissions.service';
import { AuthService } from '../../shared/services/auth.service';
import { ThemeService } from '../../shared/services/theme.service';
import {
  ActiveWorkspaceUpdatedEvent,
  Brand,
  DriveCampaign,
  FeatureTypes,
  HeaderInfo,
  WorkspaceDTO,
} from '../../shared/interfaces';
import { takeUntil } from 'rxjs/operators';
import { WorkspaceService } from '../../shared/services/workspace.service';
import { EmitterService } from '../../shared/services/emitter.service';
import { FeatureConfigService } from '../../shared/services/feature-config.service';
import { CampaignName, HelperService } from '../../shared/services/helper.service';
import { CAMPAIGN_WORKSPACE_ASSETS } from '../../shared/models/campaign-workspace-assets';
import {
  CAMPAIGN_WORKSPACE_ROUTES,
  CAMPAIGN_WORKSPACE_HEADER_LABELS,
  CAMPAIGN_WORKSPACE_COMPONENT_NAMES,
  CAMPAIGN_WORKSPACE_TRANSLATIONS,
} from '../../shared/models/campaign-workspace-translations';
import { BrandUpdatedEvent, LeftBarReporting, MenuSubtitle } from '../../shared/models';
import { AppStateService } from '../../shared/services/app-state.service';

@Component({
  selector: 'mtm-analytics-drivecampaign-index',
  templateUrl: './index.component.html',
  styleUrl: './index.component.scss',
  standalone: false,
})
export class IndexComponent implements OnInit, OnDestroy {
  private readonly featureConfigService: FeatureConfigService = inject(FeatureConfigService);

  images = CAMPAIGN_WORKSPACE_ASSETS;
  headerImage: string;
  isDashboard: boolean = true;
  title: string = '';
  subTitle: string = '';
  timelineId: string;
  ngUnsubscribe = new Subject();
  workspaceId: string;
  upperCase: boolean = false;
  isAnalytics: boolean = false;
  authUser: any;
  isHr: boolean = false;
  isYsl: boolean = false;
  isNotificationView: boolean = false;
  isTaskProject: boolean = false;
  isRecap: boolean = false;
  isGeneral: boolean = false;
  cacheBuster: string = new Date().getTime().toString();
  isWorkspaceDashboard: boolean = false;
  searchString: string;
  headerTitle: string = '';
  headerLabel: string = '';
  isArchived: boolean = false;
  isFavorites: boolean = false;
  isAll: boolean = true;
  isDriveCampaignComponet: boolean = false;
  isCampaignComponent: boolean = false;
  isProjectComponent: boolean = false;
  isSharedComponent: boolean = false;
  showSideNav: boolean = false;
  isWorkspaceActive: boolean = false;
  isCreateActive: boolean = false;
  createBtnRouts: any;
  modal: NgbModalRef;
  canCreateProject: boolean = false;
  showCampaign: boolean;
  showDriveCampaign: boolean;
  canCreateWorkspace: boolean = false;
  workspace: WorkspaceDTO | null = null;
  campaign: DriveCampaign | null = null;
  currentBrand: Brand | null;

  campaignName: string;
  campaignMainConfig: any;
  private pendingDashboardNavigation = false;

  constructor(
    private readonly timelineService: TimelineService,
    public router: Router,
    private readonly permissionService: PermissionService,
    private readonly authService: AuthService,
    private readonly themeService: ThemeService,
    private readonly workspaceService: WorkspaceService,
    private readonly appState: AppStateService
  ) {}

  ngOnInit() {
    this.themeService.updateContent({
      fullWidthContent: true,
    });
    this.timelineService.getComponentDetail();
    this.setupRouterEvents();
  }

  ngOnDestroy(): void {
    this.themeService.updateContent({
      fullWidthContent: false,
    });
    this.appState.setNavigatingToProjectDashboard(this.pendingDashboardNavigation);
    this.ngUnsubscribe.next(undefined);
    this.ngUnsubscribe.complete();
  }

  private setupRouterEvents(): void {
    this.router.events.pipe(takeUntil(this.ngUnsubscribe)).subscribe((event) => {
      if (event instanceof NavigationStart) {
        const navigatingToProjectDashboard = event.url.includes('/projects/') && event.url.includes('/dashboard');
        this.pendingDashboardNavigation = navigatingToProjectDashboard;
        this.appState.setNavigatingToProjectDashboard(navigatingToProjectDashboard);
      }
    });
  }
}
